'use client'

import { usePathname } from 'next/navigation'

// Routes rendered inside Telegram's Mini App webview.
//
// These are not "pages on a website" — they are a screen inside another app, and
// the site header, footer and header offset all read as chrome that leaked in
// from somewhere else. Telegram already draws its own title bar and close
// button above the webview, so ours is a second, competing one.
//
// Only the /telegram/ tree is chromeless. /telegram-verify is deliberately NOT:
// it is a normal browser page where the user signs in with their real
// credentials, and showing the genuine site chrome there is a trust signal
// worth keeping.
//
// /date/ is the date game player: a full-screen scene with its own close button, where the site
// header and footer would sit on top of the art.
const CHROMELESS_PREFIXES = ['/telegram/', '/date/']

export function useChromeless() {
  const pathname = usePathname()
  if (!pathname) return false
  return CHROMELESS_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}

export default useChromeless
